module.exports = __webpack_public_path__ + "static/media/Woman-with-pearl-collar-408280.7a32a65a.jpg";